const RECENT_LOGIN_CHECK_COOKIE = 'tv2HasCheckedLogin'

export const setRecentlyCheckedLoginCookie = () => {
    document.cookie = `${RECENT_LOGIN_CHECK_COOKIE}=1; domain=${window.location.hostname}; path=/; max-age=${60 * 30}`
}

export const hasRecentlyCheckedLogin = () => document.cookie
    .split(';')
    .some((item) =>
        item.trim().startsWith(`${RECENT_LOGIN_CHECK_COOKIE}=`)
    )
